import * as A from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { transformColor as t } from "../../utilities/transformations.js";
import { distort as I } from "../../helpers/distort.js";
import { grain as O } from "../../helpers/grain.js";
import { getAspectCorrectedCoordinates as D } from "../../utilities/uv.js";
const q = {
  name: "Synthesis6",
  collection: "synthesis",
  tags: ["wave", "gradient"],
  props: {
    colorA: {
      type: String,
      default: "#3900e3",
      transform: t,
      description: "The left color of the first wave"
    },
    colorB: {
      type: String,
      default: "#1a00bd",
      transform: t,
      description: "The right color of the first wave"
    },
    colorC: {
      type: String,
      default: "#ffa033",
      transform: t,
      description: "The left color of the second wave"
    },
    colorD: {
      type: String,
      default: "#d3a646",
      transform: t,
      description: "The right color of the second wave"
    },
    backgroundColor: {
      type: String,
      default: "#0a1029",
      transform: t,
      description: "The background color"
    },
    frequency: {
      type: Number,
      default: 1,
      description: "The frequency of the waves"
    },
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the waves"
    },
    amplitude: {
      type: Number,
      default: 0.07,
      description: "The amplitude of the waves"
    },
    smoothness: {
      type: Number,
      default: 0.25,
      description: "How soft the edges of the waves are"
    }
  },
  fragmentNode: (e) => {
    const {
      vec4: p,
      uv: h,
      time: n,
      sin: s,
      mix: r,
      abs: a,
      smoothstep: c,
      add: d
    } = A, i = 0.2, l = 0.04, m = 1.2, _ = 4, g = 0, o = I(h(), 0.08, 1, 28), y = s(
      o.x.mul(e.frequency.uniform).mul(Math.PI * 2).add(n.mul(e.speed.uniform))
    ).mul(e.amplitude.uniform).add(0.5).sub(i), T = s(
      o.x.mul(e.frequency.uniform).mul(Math.PI * 2).add(n.mul(e.speed.uniform).add(_))
    ).mul(e.amplitude.uniform).add(0.5).sub(i).add(g), E = r(
      e.colorA.uniform,
      e.colorB.uniform,
      o.x
    ), b = r(
      e.colorC.uniform,
      e.colorD.uniform,
      o.x
    ), v = a(o.y.sub(y)).add(o.y.mul(l)), S = a(o.y.sub(T)).add(o.y.mul(l)), u = c(
      e.smoothness.uniform,
      0,
      v
    ), f = c(
      e.smoothness.uniform,
      0,
      S
    ), { correctedUV: w } = D(), C = O(0.8)(w), N = d(
      E.mul(u),
      b.mul(f)
    ).mul(m).sub(C.mul(m));
    return p(
      r(
        e.backgroundColor.uniform,
        N,
        d(u, f).min(1)
      ),
      1
    );
  }
};
export {
  q as componentDefinition,
  q as default
};
